import Vue from "vue";
import { format } from "date-fns";

var esLocale = require("date-fns/locale/es");

Vue.filter("shorten", function(str, len) {
  if (!str) return "";
  let r = str.substring(0, len);
  if (str.length > len) {
    r += "\u2026";
  }
  return r;
});

Vue.filter("dateDDMMYYYY_slash", function(stringDate) {
  if (!stringDate) return "";

  var result = format(new Date(stringDate), "DD/MM/YYYY", {
    locale: esLocale
  });
  return result;
});

Vue.filter("dateDDMMYYYY", function(stringDate) {
  if (!stringDate) return "";

  var result = format(new Date(stringDate), "DD-MM-YYYY", {
    locale: esLocale
  });
  return result;
});

Vue.filter("dateDDMMYYYYhhmm", function(stringDate) {
  if (!stringDate) return "";
  var result = format(new Date(stringDate), "DD-MM-YYYY HH:mm", {
    locale: esLocale
  });
  return result;
});

Vue.filter("currencyEUR", function(dataCurrency) {
  if (!dataCurrency) return "";
  var importe = dataCurrency.toFixed(2).toString();
  importe = importe.replace(",", "");
  importe = importe.replace(".", ",");
  return importe + " \u20AC";
});

Vue.filter("numericFormat", function(dataCurrency) {
  if (!dataCurrency) return "";

  var data = dataCurrency.toFixed(2).replace(/./g, function(c, i, a) {
    return i && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
  });
  return data;
});

Vue.filter("booleanFilter", function(b) {
  return b ? "Si" : "No";
});

// console.log('Fecha de hoy: ' + format(31536000000 * 100, "DD-MM-YYYY", {
//   locale: esLocale
// }))

// console.log('Fecha de hoy: ' + format(31536000000 * 100, "DD-MM-YYYY HH:mm", {
//   locale: esLocale
// }))
